import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={reduce ? { duration: 0 } : { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

// Line-by-line masked reveal for large headings.
// Renders plain, fully-visible text when the user prefers reduced motion.
export const MaskedLines = ({ lines, className = "", delay = 0 }) => {
  const reduce = useReducedMotion();
  if (reduce) {
    return (
      <span className={className} aria-label={lines.join(" ")}>
        {lines.map((line, i) => (
          <span key={i} className="block">{line}</span>
        ))}
      </span>
    );
  }
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <motion.span
          key={i}
          className="block"
          initial={{ opacity: 0, y: "0.35em" }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      ))}
    </span>
  );
};
